/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import ZoneDTO from '../../../dto/ZoneDTO';
import Switches from '../../../components/fields/Switches/Switches';
import {
  Button, Col, Icons, Row,
} from '../../../components/base/BootstrapComponents/BootstrapComponents';
import AddressDTO from '../../../dto/AddressDTO';
import { getSettingsData } from '../../Settings/reducer';
import ZonePresetModal from './ZonePresetModal';
import {
  errorNotification,
  successNotification,
} from '../../Notifications/notificationDecorator';
import { getResponseError } from '../../../utils/utils';
import { createZone, saveZone } from '../actions';

export default function ZoneForm(props) {
  const dispatch = useDispatch();
  const {
    zone = {},
    position = {},
    cancel = () => {},
    handleSetZone = () => {},
    polygon = [],
    loadData = () => {},
  } = props;
  const intl = useIntl();
  const { formatMessage } = intl;
  const [showDialog, setShowDialog] = useState(false);
  const [presets, setPresets] = useState(zone.presets || []);
  const {
    presetsList,
  } = useSelector(getSettingsData);
  const DTO = new ZoneDTO();
  const attributes = DTO.getAttributesByName();
  const addressDto = new AddressDTO();
  const addressAttributes = addressDto.getAttributesByName();
  const { control, reset, getValues } = useForm({
    mode: 'onBlur',
    defaultValues: { presets: [], save_all_fixation: false, ...zone },
    resetOptions: {
      keepDirtyValues: true, // user-interacted input will be retained
      keepErrors: true, // input errors will be retained with value update
    },
  });
  const handleAddPresets = event => setShowDialog(true);
  const handleClose = () => setShowDialog(false);
  const deletePreset = id => event => {
    const newValue = [...presets];
    const index = newValue.indexOf(id);
    if (index > -1) {
      newValue.splice(index, 1);
      setPresets(newValue);
    }
  };

  const disabled = false;
  const prefix = 'address';
  const selectPreset = p => setPresets(p);
  const save = () => {
    const values = getValues();
    const data = {
      ...values,
      border: polygon,
      presets,
      active: true,
      position_id: position.id,
    };
    if (!zone || !zone.id) {
      dispatch(createZone(data)).then(() => {
        loadData();
        cancel();
        successNotification(formatMessage({ id: 'zone.create' }), formatMessage({ id: 'zone.create.success' }));
      })
        .catch(response => errorNotification(formatMessage({ id: 'zone.create' }), getResponseError(response)));
    } else {
      dispatch(saveZone({
        id: zone.id,
        data,
      })).then(() => {
        loadData();
        successNotification(formatMessage({ id: 'zone.save' }), formatMessage({ id: 'zone.save.success' }));
      })
        .catch(response => errorNotification(formatMessage({ id: 'zone.save' }), getResponseError(response)));
    }
  };

  const cancelForm = () => {
    cancel();
    reset();
  };

  return (
    <>
      <div className="settings-form">
        <div className="settings-view-form zone-form custom-scroll-theme">
          <div className="settings-view-row">
            <FieldDTO
              control={control}
              component={TextInputWithLabel}
              dtoObject={attributes.name}
              variant="material"
            />
            <FieldDTO
              control={control}
              component={Switches}
              dtoObject={attributes.save_all_fixation}
              variant="material"
              className="mt-2"
              withLabel
            />
          </div>
          <div>
            <Row className="mt-3">
              <Col columns={2}>
                <FieldDTO
                  control={control}
                  component={TextInputWithLabel}
                  dtoObject={addressAttributes.postal_code}
                  namePrefix={prefix}
                  disabled={disabled}
                  variant="material"
                />
              </Col>
              <Col columns={3}>
                <FieldDTO
                  control={control}
                  component={TextInputWithLabel}
                  dtoObject={addressAttributes.country}
                  namePrefix={prefix}
                  disabled={disabled}
                  variant="material"
                />
              </Col>
              <Col columns={4}>
                <FieldDTO
                  control={control}
                  component={TextInputWithLabel}
                  dtoObject={addressAttributes.region}
                  namePrefix={prefix}
                  disabled={disabled}
                  variant="material"
                />
              </Col>
              <Col columns={3}>
                <FieldDTO
                  control={control}
                  component={TextInputWithLabel}
                  dtoObject={addressAttributes.area}
                  namePrefix={prefix}
                  disabled={disabled}
                  variant="material"
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col columns={4}>
                <FieldDTO
                  control={control}
                  component={TextInputWithLabel}
                  dtoObject={addressAttributes.city}
                  namePrefix={prefix}
                  disabled={disabled}
                  variant="material"
                />
              </Col>
              <Col columns={4}>
                <FieldDTO
                  control={control}
                  component={TextInputWithLabel}
                  dtoObject={addressAttributes.place}
                  namePrefix={prefix}
                  disabled={disabled}
                  variant="material"
                />
              </Col>
              <Col columns={4}>
                <FieldDTO
                  control={control}
                  component={TextInputWithLabel}
                  dtoObject={addressAttributes.street}
                  namePrefix={prefix}
                  disabled={disabled}
                  variant="material"
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col columns={2}>
                <FieldDTO
                  control={control}
                  component={TextInputWithLabel}
                  dtoObject={addressAttributes.house}
                  namePrefix={prefix}
                  disabled={disabled}
                  variant="material"
                />
              </Col>
              <Col columns={2}>
                <FieldDTO
                  control={control}
                  component={TextInputWithLabel}
                  dtoObject={addressAttributes.external}
                  namePrefix={prefix}
                  disabled={disabled}
                  variant="material"
                />
              </Col>
              <Col columns={2}>
                <FieldDTO
                  control={control}
                  component={TextInputWithLabel}
                  dtoObject={addressAttributes.building}
                  namePrefix={prefix}
                  disabled={disabled}
                  variant="material"
                />
              </Col>
              <Col columns={2}>
                <FieldDTO
                  control={control}
                  component={TextInputWithLabel}
                  dtoObject={addressAttributes.letter}
                  namePrefix={prefix}
                  disabled={disabled}
                  variant="material"
                />
              </Col>
              <Col columns={3}>
                <FieldDTO
                  control={control}
                  component={TextInputWithLabel}
                  dtoObject={addressAttributes.apartment}
                  namePrefix={prefix}
                  disabled={disabled}
                  variant="material"
                />
              </Col>
            </Row>
          </div>

          <div className="f4 mt-3">{formatMessage({ id: 'zone' })}</div>
          <Button className="" variant="link" onClick={handleSetZone}><Icons
            customIcon
            icon="plus"
          /> {formatMessage({ id: 'zone.set' })}
          </Button>
          <div className="f4 mt-3">{formatMessage({ id: 'presets.violation' })}</div>
          {presets && presets.length > 0 ? (
            <div className="presets-list mt-3">
              {(presets || []).map((presetId, key) => {
                const preset = presetsList.find(p => p.id === presetId);
                if (!preset) return null;
                return (
                  <div key={key} className="presets-list-item">
                    <div className="presets-list-name">
                      {preset.name || ''}
                    </div>
                    <div className="presets-list-delete" onClick={deletePreset(presetId)}>
                      <Icons width={22} height={22} customIcon icon="trash" className="button-icons" />
                    </div>
                  </div>
                );
              })}
            </div>
          ) : null}

          <Button className="" variant="link" onClick={handleAddPresets}><Icons
            customIcon
            icon="plus"
          /> {formatMessage({ id: 'app.create' })}
          </Button>
          {showDialog ? <ZonePresetModal handleClose={handleClose} handleSave={selectPreset} selectedPresets={presets} /> : null}
        </div>
      </div>
      <div className="settings-footer">
        <Button className="clear-show" onClick={save}>{formatMessage({ id: 'app.save' })}</Button>
        <Button className="clear-data" variant="secondary" onClick={cancelForm}>{formatMessage({ id: 'app.cancel' })}</Button>
      </div>
    </>
  );
}
